import { cn } from '../../shared/lib/utils.ts'
import {
  SUPPORT_MAX_URL,
  SUPPORT_TELEGRAM_URL,
} from '../../shared/constants.ts'

const contacts = [
  {
    title: 'Max',
    img: '/images/contacts/max.svg',
    url: SUPPORT_MAX_URL,
    urlTitle: 'max.ru',
  },
  {
    title: 'Telegram',
    img: '/images/contacts/telegram.svg',
    url: SUPPORT_TELEGRAM_URL,
    urlTitle: '@speakalot_eng',
  },
]

export function ContactsBlock(props: {
  full?: boolean
  className?: string
  compact?: boolean
  isSubscriptionView?: boolean
}) {
  return (
    <div
      className={cn(
        'flex',
        props.compact
          ? 'justify-around gap-18'
          : props.full
            ? 'justify-around gap-60'
            : 'justify-center gap-32',
        props.className,
      )}
    >
      {contacts.map((x, i) => {
        return (
          <a
            rel="noreferrer"
            target="_blank"
            href={x.url}
            className="flex flex-col items-center"
            key={i}
          >
            {!props.isSubscriptionView ? (
              <img
                alt={x.title}
                className={cn(props.full ? 'h-64' : 'h-32')}
                src={x.img}
              />
            ) : null}
            {props.full && (
              <>
                <span className="mt-8 text-18 font-extrabold">{x.title}</span>
                <span className="mt-4 text-12 font-medium">{x.urlTitle}</span>
              </>
            )}
          </a>
        )
      })}
    </div>
  )
}
